import type { Board } from "../../board";
import { PRIORITY_LAST, type ProcessableThing } from "../../interfaces";
import { PhysicalThing } from "../../physicalThing";
import { deserializeXY } from "../../serialization";
import type { XY } from "../../xy";
import { ZOrder } from "../../zOrder";

export class Trigger extends PhysicalThing implements ProcessableThing {
	static key = "Trigger";
	private conditions: Array<() => boolean> = [];
	private actions: Array<() => void> = [];

	constructor(xy: XY) {
		super(xy, false);
	}

	isVisible(): boolean {
		return false;
	}

	getZOrder(): number {
		return ZOrder.SCENARIO;
	}

	addCondition(fn: () => boolean): void {
		this.conditions.push(fn);
	}

	addAction(fn: () => void): void {
		this.actions.push(fn);
	}

	processTurn(_board: Board): void {
		if (this.conditions.every((fn) => fn())) {
			for (const action of this.actions) {
				action();
			}
		}
	}

	getProcessPriority(): number {
		return PRIORITY_LAST;
	}

	static deserialize(data: any): Trigger {
		const t = new Trigger(deserializeXY(data.xy));
		t.visualId = data.visualId;
		return t;
	}
}
